<nz-drawer
  [nzVisible]="visible"
  [nzWidth]="width"
  nzPlacement="right"
  [nzTitle]="drawerTitleTpl"
  [nzFooter]="drawerFooterTpl"
  (nzOnClose)="close()"
  [nzClosable]="false"
>
  <ng-container *nzDrawerContent>
    <div class="fd-body">
      @if (currentTemplate) {
        <ng-container *ngTemplateOutlet="currentTemplate"></ng-container>
      }
    </div>
  </ng-container>
</nz-drawer>

<ng-template #drawerTitleTpl>
  <div class="fd-header">
    <div class="fd-header-left">
      <span nz-icon nzType="filter" class="fd-header-icon"></span>
      <span class="fd-header-title">Filters</span>
    </div>
    <span nz-icon nzType="close" class="fd-close-icon" (click)="close()" nz-tooltip nzTooltipTitle="Close"></span>
  </div>
</ng-template>

<ng-template #drawerFooterTpl>
  <div class="fd-footer">
    @if (footerExtra) {
      <ng-container *ngTemplateOutlet="footerExtra"></ng-container>
    }
    <button nz-button nzType="default" (click)="onReset()" class="fd-reset-btn">
      <span nz-icon nzType="close-circle"></span>
      Reset
    </button>
    <button nz-button nzType="primary" (click)="onApply()" class="fd-apply-btn">
      <span nz-icon nzType="search"></span>
      Apply Filters
    </button>
  </div>
</ng-template>
